var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof portalCampaignManagerLib_v4_0_4 !== "undefined") return resolve();
	__webpack_require__.l("https://festatic.playgami.scopely.com/portal-campaign-manager-lib/v4_0_4/remoteEntry.js", (event) => {
		if(typeof portalCampaignManagerLib_v4_0_4 !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "portalCampaignManagerLib_v4_0_4");
}).then(() => (portalCampaignManagerLib_v4_0_4));